<template>
  <div class="product-image-upload">
    <div
      class="image-container"
      @click="handleImageClick"
      :class="{ 'has-image': hasImage }"
    >
      <v-img :src="imageUrl" aspect-ratio="1" contain class="product-image" />

      <div
        class="image-background d-flex  align-center justify-center"
        v-if="!hasImage && !isUploading"
      >
        <v-icon color="grey lighten-1" size="20">
          mdi-camera
        </v-icon>
        <p class="background-text ">
          {{ placeholder }}
        </p>
      </div>

      <div
        class="upload-progress d-flex align-center justify-center"
        v-if="isUploading"
      >
        <v-progress-circular
          :value="uploadProgress"
          :size="20"
          :width="3"
          color="primary"
        >
        </v-progress-circular>
        <p class="caption ml-2 mb-0 grey--text text--darken-1">
          {{ uploadedFiles }}/{{ totalFiles }} imagens
        </p>
      </div>
    </div>

    <input
      class="d-none"
      ref="fileInput"
      type="file"
      accept="image/*"
      multiple
      @input="handleFileInput"
    />
  </div>
</template>

<script>
export default {
  name: "ProductImageUpload",

  props: {
    value: {
      type: String,
      default: null,
    },

    defaultImage: {
      type: String,
      default: null,
    },

    placeholder: {
      type: String,
      default: "Adicionar imagens do produto",
    },

    productId: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      imageUrl: null,
      selectedFile: null,
      isUploading: false,
      uploadProgress: 0,
      totalFiles: 0,
      uploadedFiles: 0,
    };
  },

  computed: {
    hasImage() {
      return this.imageUrl && this.imageUrl !== this.defaultImage;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.imageUrl = newVal;
        } else {
          this.imageUrl = this.defaultImage;
        }
      },
    },
  },

  methods: {
    handleImageClick() {
      this.$refs.fileInput.click();
    },

    async handleFileInput() {
      const input = this.$refs.fileInput;

      const files = Array.from(input.files);

      if (files.length === 0) return;

      this.isUploading = true;

      this.totalFiles = files.length;

      this.uploadedFiles = 0;

      this.uploadProgress = 0;

      this.$emit("uploading", true);

      this.$emit("upload-started", { total: files.length });

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const formData = new FormData();

        formData.append("product_image", file);

        if (this.productId) {
          formData.append("product_id", this.productId);
        }

        try {
          await this.$http.$post("product/upload-image", formData);
          this.uploadedFiles++;
          this.uploadProgress = Math.round(
            (this.uploadedFiles / this.totalFiles) * 100
          );
        } catch (error) {
          console.error("Erro ao fazer upload:", file.name, error);
        }
      }

      this.isUploading = false;

      this.$emit("upload-complete");

      this.$refs.fileInput.value = "";
    },
  },
};
</script>

<style scoped>
.product-image-upload {
  position: relative;
}

.image-container {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  border: 3px dashed #e0e0e0;
  transition: all 0.3s ease;
  background-color: #fafafa;
}

.image-container:hover {
  border-color: #1976d2;
}

.image-container.has-image {
  border: 3px solid #e0e0e0;
}

.product-image {
  width: 100%;
  height: 100%;
}

.image-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
}

.background-text {
  color: #bdbdbd;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  text-align: center;
}

.upload-progress {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
}
</style>
